<template>
    <div class="page__about">
        <div class="page__wrapper">
            <div class="fader"></div>

            <Preloader />

            <Header />
            <section class="about page_about">
                <div class="content_wrapper">
                    <h1 class="about__h1 detectMobVisibility">
                        <span class="textHide">
                            <span>{{ $t('about.title') }}</span>
                        </span>
                    </h1>
                    <div class="about__content">
                        <div>
                            <h2 class="about__h2 detectMobVisibility">
                                <span class="textHide sec_inst">
                                    <span>{{ $t('about.history') }}</span>
                                </span>
                            </h2>
                            <div
                                class="about__text textFade detectMobVisibility"
                                v-html="$t('about.history_descr')"
                            ></div>
                        </div>
                        <div>
                            <h2 class="about__h2 detectMobVisibility">
                                <span class="textHide sec_inst">
                                    <span>{{ $t('about.business') }}</span>
                                </span>
                            </h2>
                            <div
                                class="about__text textFade sec_inst detectMobVisibility"
                                v-html="$t('about.business_descr')"
                            ></div>
                        </div>
                        <div>
                            <h2 class="about__h2 detectMobVisibility">
                                <span class="textHide sec_inst">
                                    <span>{{ $t('about.people') }}</span>
                                </span>
                            </h2>
                            <div
                                class="about__text textFade sec_inst detectMobVisibility"
                                v-html="$t('about.people_descr')"
                            ></div>
                        </div>
                        <!-- <div class="employees">
                            <div
                                class="employees__item textFade detectMobVisibility"
                                v-for="(item, index) in employees"
                                :key="index"
                            >
                                <img
                                    v-bind:src=" require('../assets/images/'+item['img']) "
                                    class="employees__image"
                                    alt
                                />
                                <div class="employees__desc">
                                    <div
                                        class="employees__name"
                                    >{{ item.name[curVue.$i18n.locale] }}</div>
                                    <div
                                        class="employees__position"
                                    >{{ item.position[curVue.$i18n.locale] }}</div>
                                </div>
                            </div>
                        </div>-->
                    </div>
                    <div class="quote">
                        <h2 class="quote__h2 detectMobVisibility">
                            <span class="textHide sec_inst">
                                <span>{{ $t('about.quote_title') }}</span>
                            </span>
                        </h2>
                        <div class="quote__content textFade sec_inst detectMobVisibility">
                            <span class="quote__icon">
                                <span class="icon-quote"></span>
                                <span class="icon-quote"></span>
                            </span>
                            <div v-html="$t('about.quote')"></div>
                        </div>
                        <div
                            class="quote__author detectMobVisibility"
                        >{{ $t('about.quote_author') }}</div>
                        <div
                            class="quote__position detectMobVisibility"
                        >{{ $t('about.quote_author_position') }}</div>
                    </div>
                </div>
            </section>
        </div>
        <Footer />
    </div>
</template>

<script>
import i18n from "../lang/lang";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Preloader from "@/components/preloader.vue";
// import emps from "../../public/employees_list.json";

export default {
    ComponentName: "about",
    components: {
        Header,
        Footer,
        Preloader
    },
    data() {
        return {
            // employees: emps.employees,
            curVue: this
        };
    },
    created() {},
    mounted() {
        var _this = this;

        $("body")
            .removeClass("hideTopBar")
            .addClass("lightBack scrolledPage aboutPage faderOut");

        if ($("body").hasClass("aboutPage")) {
            var scrollDelay = 0;
            $(window).scroll(function() {
                clearTimeout(scrollDelay);

                scrollDelay = setTimeout(function() {
                    _this.scrollDetect($(this).scrollTop());
                }, 150);
            });
        }
    },
    beforeDestroy() {
        $("body").removeClass("lightBack scrolledPage aboutPage");
    }
};
</script>

<style lang="stylus" scoped>
.content_wrapper {
    position: relative;
    background: none;
}

.page_about {
    padding-top: 70px;
    padding-bottom: 80px;
}

.about__h1 {
    max-width: 814px;
    margin: 0 auto 48px auto;
    font-weight: bold;

    @media (min-width: 1024px) {
        padding-left: 170px;
    }
}

.about__content {
    @media (min-width: 1024px) {
        padding-left: 170px;
        display: grid;
        grid-template-rows: repeat(2, 1fr);
        grid-template-columns: repeat(2, 346px);
        grid-gap: 44px 122px;
        justify-content: center;
    }

    @media (min-width: 1600px) {
        padding-left: 150px;
    }
}

.about__text {
    line-height: 1.7;
    padding: 24px 0 48px;
}

// .employees {
// display: flex;
// flex-flow: row wrap;
// justify-content: space-between;
// margin: 0 -32px;

// @media (min-width: 685px) {
// margin: 0 auto;
// }

// @media (max-width: 445px) {
// margin: 0;
// }

// @media (max-width: 380px) {
// margin: 0 -20px;
// }
// }

// .employees__item {
// flex: 1 0 25%;
// display: flex;
// flex-direction: column;
// align-items: flex-start;

// @media (max-width: 1200px) {
// width: 224px;
// flex: initial;
// align-items: center;
// }

// @media (max-width: 380px) {
// width: 50%;
// }
// }

// .employees__image {
// display: block;
// width: 100%;
// max-width: 224px;
// }

// .employees__desc {
// width: 100%;
// padding: 20px 0;
// box-sizing: border-box;

// @media (max-width: 380px) {
// padding: 20px;
// }
// }

// .employees__position {
// margin: 8px 0 68px;
// color: #808080;
// line-height: 1.2;
// }
.quote {
    @media (min-width: 1024px) {
        padding-left: 130px;
        max-width: 956px;
        margin: 0 auto;
    }
}

.quote__h2 {
    font-size: 24px;
    text-align: center;
}

.quote__content {
    padding: 70px 0 32px;
    line-height: 1.6;
    font-size: 18px;
    position: relative;

    @media (min-width: 1024px) {
        font-size: 36px;
    }
}

.quote__icon {
    position: absolute;
    left: -40px;
    top: 50px;
    font-size: 45px;
    color: #2858A2;
    z-index: -1;

    @media (min-width: 1024px) {
        font-size: 94px;
        top: 25px;
        left: -70px;
    }
}

.icon-quote {
    position: absolute;
    display: block;
    top: 0;
    left: -10px;
    -webkit-transform: rotate(-15deg);
    -moz-transform: rotate(-15deg);
    transform: rotate(-15deg);

    @media (max-width: 1023px) {
        left: -4px;
    }

    &:last-child {
        left: 40px;

        @media (max-width: 1023px) {
            left: 20px;
        }
    }
}

.quote__position {
    color: #808080;
    margin: 4px 0 80px;
}
</style>
